import React, { useEffect, useState } from "react";
import Table from "../../common/Table";

const BalanceDataTables = ({ typeID, typeName, name, data }) => {
  const columns = {
    "Students Fee": [
      { path: "id", label: "شماره" },
      { path: "aria_id", label: "کد دانشجویی" },
      { path: "payment_date", label: "تاریخ" },
      { path: "student_name", label: "نام" },
      { path: "student_father_name", label: "نام پدر" },
      { path: "class_desc", label: "صنف" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    Grants: [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع درامد" },
      { path: "receipt_date", label: "تاریخ" },
      { path: "received_by_staff", label: "دریافت کننده" },
      { path: "remark", label: "ملاحظه" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    "Academic Support": [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع درامد" },
      { path: "receipt_date", label: "تاریخ" },
      { path: "received_by_staff", label: "دریافت کننده" },
      { path: "remark", label: "ملاحظه" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    Gifts: [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع درامد" },
      { path: "receipt_date", label: "تاریخ" },
      { path: "received_by_staff", label: "دریافت کننده" },
      { path: "remark", label: "ملاحظه" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    "Misc Revenues": [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع درامد" },
      { path: "receipt_date", label: "تاریخ" },
      { path: "received_by_staff", label: "دریافت کننده" },
      { path: "remark", label: "ملاحظه" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    "Teacher Salaries": [
      { path: "id", label: "شماره" },
      { path: "teacher_name", label: "نام" },
      { path: "payment_date", label: "تاریخ" },
      { path: "paid_by_staff_name", label: "پرداخت کننده" },
      { path: "modified_by_staff_name", label: "ثبت کننده" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "remark", label: "ملاحظه" },
      { path: "amount", label: "مبلغ" },
    ],
    "Staff Salaries": [
      { path: "id", label: "شماره" },
      { path: "staff_name", label: "نام" },
      { path: "payment_date", label: "تاریخ" },
      { path: "paid_by_staff_name", label: "پرداخت کننده" },
      { path: "modified_by_staff_name", label: "ثبت کننده" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "remark", label: "ملاحظه" },
      { path: "amount", label: "مبلغ" },
    ],
    "Direct Expenses": [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع مصرف" },
      { path: "payment_date", label: "تاریخ پرداخت" },
      { path: "contractor", label: "طرف قرارداد" },
      { path: "paid_by_staff", label: "پرداخت کننده" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "remark", label: "ملاحظه" },
      { path: "amount", label: "مبلغ" },
    ],
    "Indirect Expenses": [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع مصرف" },
      { path: "payment_date", label: "تاریخ پرداخت" },
      { path: "contractor", label: "طرف قرارداد" },
      { path: "paid_by_staff", label: "پرداخت کننده" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "remark", label: "ملاحظه" },
      { path: "amount", label: "مبلغ" },
    ],
    "Debt Payments": [
      { path: "id", label: "شماره" },
      { path: "creditor", label: "نام" },
      { path: "payment_date", label: "تاریخ" },
      { path: "paid_by_staff_name", label: "پرداخت کننده" },
      { path: "modified_by_staff_name", label: "ثبت کننده" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "remark", label: "ملاحظه" },
      { path: "amount", label: "مبلغ" },
    ],
  };

  const [_data, setData] = useState([]);

  useEffect(() => {
    let newData = [];

    if (data) {
      newData = data.filter((d) => d[typeName] === parseInt(typeID));
    }

    setData(newData);
  }, [data]);

  return (
    <div className="print-table-area">
      <Table data={_data} columns={columns[name]} />
    </div>
  );
};

export default BalanceDataTables;
